import { Component, OnInit } from '@angular/core';
import { Constantes } from '../../../shared/constant/constantes';
import { VisualizadorService } from 'src/app/components/shared/service/visualizador.service';
import { SerieTematicaDisponible } from 'src/app/components/shared/entities/serie-tematica-disponible';
import { MenuAlternoComponent } from '../../public/menu-alterno/menu-alterno.component';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-detalle-catalogo',
  templateUrl: './detalle-catalogo.component.html',
  styleUrls: ['./detalle-catalogo.component.css']
})
export class DetalleCatalogoComponent implements OnInit {

  constructor(private service: VisualizadorService, private router: Router, private title: Title, private meta: Meta) {}

  public ma: MenuAlternoComponent = new MenuAlternoComponent();
  public constantes: Constantes = new Constantes();
  displayedColumns: string[] = ['serie', 'tablasPreconstruidas', 'graficadorSeries', 'buscadorSeries', 'indicadoresDiarios'];
  seriesTematicasDisponibles: SerieTematicaDisponible[] = [];
  seriesTematicasDisponiblesFiltrada: SerieTematicaDisponible[] = [];
  ngOnInit(): void {
    this.title.setTitle('Catálogo detallado de datos');
    this.meta.updateTag({ name: 'description', content: 'Muestra el listado de series y en que productos están disponibles' });

    this.service.getSerieTematicaDisponible().subscribe({
      next: response => {
        this.seriesTematicasDisponibles = response;
        this.seriesTematicasDisponiblesFiltrada = this.seriesTematicasDisponibles;
      }
    });
  }

  getImage(inProduct: string) {
    if (inProduct === 'SI') {
      return './assets/img/chulo_verde.svg';
    } else {
      return './assets/img/cruz_roja.svg';
    }
  }

  filtrar(palabra: string) {
    if (palabra) {
    this.seriesTematicasDisponiblesFiltrada = this.seriesTematicasDisponibles.filter(serie => { return serie.descripcion?.toLowerCase().includes(palabra.toLowerCase()) })
    } else {
      this.seriesTematicasDisponiblesFiltrada = this.seriesTematicasDisponibles;
    }
  }

  irBuscadorSeries(id: number) {
    this.router.navigateByUrl('https://obipru.banrep.gov.co/buscador-de-series/#/consolidado')    
  }

}
